/**
 * Mixin pour la traduction des placeholders dans les composants de champs
 */
export default {
  methods: {
    translatePlaceholder(key) {
      if (!key) return ''
      const keyStr = String(key)
      
      // Si le placeholder contient un point, c'est probablement une clé i18n
      if (keyStr.includes('.')) {
        // Essayer de traduire avec $t
        const translated = this.$t(keyStr)
        // Si la traduction retourne la même clé, c'est que la traduction n'existe pas
        if (translated !== keyStr) {
          return translated
        }
      }
      
      // Sinon, retourner le placeholder tel quel
      return keyStr
    }
  }
}
